import {CompanyNewsTile} from "@irati/types"

const companyNewsToRows = (items: CompanyNewsTile[]): CompanyNewsTile[][] => {
  // First, group by xpos using reduce
  const grouped = items.reduce(
    (acc, curr) => {
      const xposition = curr.xpos
      if (!acc[xposition]) {
        acc[xposition] = []
      }
      acc[xposition].push(curr)
      return acc
    },
    {} as {[key: number]: CompanyNewsTile[]}
  )

  // Convert the grouped object to array of arrays and sort each inner array by ypos
  return Object.values(grouped).map((group) => group.sort((a, b) => a.ypos - b.ypos))
}

export default companyNewsToRows
